import whenNoRunningUiLessAddinOnHostItem from './utils/UiLessObserver';
import {
    closeNonPersistentTaskPaneAddinCommand,
    removeExtensibilityFrameworkComponent,
} from 'owa-addins-view';
import { destroyExtensibilityNotifications } from 'owa-addins-apis';
import { deleteAdapter } from 'owa-addins-adapters';
import {
    destroyExtensibilityHostItem,
    isHostItemActive,
    closeAllAutoRunCommandsforHostItemIndex,
} from 'owa-addins-store';
import getProjection from 'owa-popout-v2/lib/utils/getProjection';
import type { AddinInstance } from 'owa-addins-store';

export default function deinitializeAddinsForItem(
    hostItemIndex: string,
    targetWindow: Window = window //For Calendar fallback is window
) {
    const projection = getProjection(targetWindow);
    const tabId = projection ? projection.tabId : targetWindow === window ? 'Main' : null;
    const addinInstance: AddinInstance = {
        hostItemIndex: hostItemIndex,
        tabId: tabId,
    };

    const addinInstanceString: string = JSON.stringify(addinInstance);

    destroyExtensibilityNotifications(hostItemIndex);
    closeNonPersistentTaskPaneAddinCommand(hostItemIndex, targetWindow);
    destroyExtensibilityHostItem(hostItemIndex);
    closeAllAutoRunCommandsforHostItemIndex(hostItemIndex, targetWindow);
    whenNoRunningUiLessAddinOnHostItem(addinInstanceString, deinitializeAddinsForNonActiveHostItem);
    removeExtensibilityFrameworkComponent(targetWindow);
}

function deinitializeAddinsForNonActiveHostItem(hostItemIndex: string) {
    if (isHostItemActive(hostItemIndex)) {
        return;
    }

    deleteAdapter(hostItemIndex);
}
